import { render, staticRenderFns } from "./BusinessItem.vue?vue&type=template&id=3286948f&scoped=true"
import script from "./BusinessItem.vue?vue&type=script&lang=js"
export * from "./BusinessItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286948f",
  null
  
)

export default component.exports